import { Radio } from "antd";
import React from "react";
import '../styles/FormInput.css';

const FormRadio = (props) => {
    return (
        <div className="form-input-container" style={{...props.style}}>
            <div className="form-label">
                {props.label}{props.mandatory ? <span className="mandatory">*</span> : <></>}
            </div>
            <div className={props.buttonLabel ? "input-field-container margin-r-10" : "input-field-container"}>
                <Radio.Group name={props.name}
                    value={props.value ? props.value : null} onChange={(e) => { props.onchange(e.target.value) }} options={props.options}/>
            </div>
        </div>
       
    )
}
export default FormRadio;